import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import { addImageParams, GetImageUrlParams } from '@/utils/urls';

import { RelatedCategory } from '../../RelatedCategories';

export const CategoryCard = ({ href, imageUrl, imageVersion, title }: RelatedCategory) => {
    const imageOptions: GetImageUrlParams = {
        height: 220,
        imageVersion,
        quality: 80,
        sharpen: true,
        width: 220,
    };

    const formattedImageUrl = addImageParams({ ...imageOptions, url: imageUrl });

    return (
        <Link
            className="group flex flex-1 flex-col items-center gap-xs no-underline"
            href={href}
        >
            <div className="bg-gray-200 flex aspect-square w-full items-center justify-center overflow-hidden rounded-full border border-border-secondary smMax:h-[96px] smMax:w-[96px]">
                <img
                    alt={title}
                    className="h-full w-full rounded-full object-contain"
                    loading="eager"
                    src={formattedImageUrl}
                />
            </div>
            <H5 className="text-center">{title}</H5>
        </Link>
    );
};
